export const BOARD_ART_WIDTH=6943;
export const BOARD_ART_HEIGHT=3024;

export function milestoneSlots<T extends {slot?:number}>(milestones:T[]){
  const used=new Set<number>();
  return milestones.map(m=>{let slot=m.slot;if(typeof slot!=='number'||!Number.isInteger(slot)||slot<0||used.has(slot)){slot=0;while(used.has(slot))slot++;}used.add(slot);return{...m,slot};});
}
export function milestonePosition(slot:number,board:string){
  return {x:(board==='B'?6400:6390)/BOARD_ART_WIDTH*100,y:(72+slot*112)/BOARD_ART_HEIGHT*100,width:466/BOARD_ART_WIDTH*100,height:96/BOARD_ART_HEIGHT*100};
}

export function happinessSlots(value:number,board:string){
  const count=Math.min(30,Math.max(0,Math.floor(Number.isFinite(value)?value:0)));
  const x=board==='B'?6220:6212,first=board==='B'?2912:2914,last=board==='B'?112:110;
  return Array.from({length:count},(_,i)=>({value:i+1,x:x/BOARD_ART_WIDTH*100,y:(first-i*(first-last)/29)/BOARD_ART_HEIGHT*100}));
}
